var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _g2, _path10, _path11, _ellipse, _ellipse2, _circle, _circle2, _path12, _path13, _path14, _g3, _g4, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFishResult11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 784.07 350",
    style: {
      enableBackground: "new 0 0 784.07 350"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.1;fill:url(#SVGID_2_);}\n\t.st2{opacity:0.8;fill:url(#SVGID_3_);}\n\t.st3{fill:url(#SVGID_4_);}\n\t.st4{fill:url(#SVGID_5_);}\n\t.st5{fill:url(#SVGID_6_);}\n\t.st6{fill:url(#SVGID_7_);}\n\t.st7{fill:url(#SVGID_8_);}\n\t.st8{opacity:0.7;fill:url(#SVGID_9_);}\n\t.st9{opacity:0.5;}\n\t.st10{fill:#FF4828;}\n\t.st11{fill:url(#SVGID_10_);}\n\t.st12{opacity:0.5;fill:url(#SVGID_11_);}\n\t.st13{opacity:0.1;fill:url(#SVGID_12_);}\n\t.st14{fill:url(#SVGID_13_);}\n\t.st15{fill:#FFFFFF;}\n\t.st16{fill:url(#SVGID_14_);}\n\t.st17{fill:url(#SVGID_15_);}\n\t.st18{fill:url(#SVGID_16_);}\n\t.st19{opacity:0.6;}\n\t.st20{opacity:0.3;}\n\t.st21{opacity:0.6;fill:url(#SVGID_17_);}\n\t.st22{opacity:0.6;fill:url(#SVGID_18_);}\n\t.st23{opacity:0.6;fill:url(#SVGID_19_);}\n\t.st24{fill:url(#SVGID_20_);}\n\t.st25{opacity:0.4;}\n\t.st26{opacity:0.6;fill:url(#SVGID_21_);}\n\t.st27{opacity:0.6;fill:url(#SVGID_22_);}\n\t.st28{opacity:0.6;fill:url(#SVGID_23_);}\n\t.st29{fill:url(#SVGID_24_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.5175,
    y1: 353.7403,
    x2: 397.7892,
    y2: 91.6733
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7B681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5104,
    style: {
      stopColor: "#F6774C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F53919"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M781.24,235.62c-1.84,1.84-2.61-2.67-6.93-3.01c-8.56-0.69-71.89,24.51-82.06,22.88c-2-0.32-5-0.19-8.52,0.23 c-4.6,0.55-10.1,1.6-15.45,2.75c-0.01,0-0.01,0-0.03,0c-1.01,0.23-2.03,0.45-3.03,0.68c-3.2,0.72-6.25,1.47-8.93,2.13 c-5.65,1.43-9.6,2.54-9.6,2.54c-1.27,0.33-2.51,0.65-3.72,0.95c-32.65,8.27-49.37,9.35-94.76,11.14 c4.14-7.22,7.03-12.29,7.03-12.29l-34.48,5.23c-5.59,3.8-12.54,6.73-19.86,8.98c-0.79,0.03-1.58,0.07-2.39,0.1 c-89.01,3.92-242.73-52.94-242.73-52.94c-77.45-27.74-119.28,0.46-119.28,0.46c-46.73,22.39-101.92,32.81-125.49,36.5 c-6.18,0.97-11.64-4.18-10.97-10.4c0.99-9.08,3.5-21.4,9.77-30.03c11.1-15.26,15.03-38.83,15.72-50.16s-16.18-47.62-21.5-70.97 c-5.32-23.36,0-22.44,0-22.44c17.15-0.17,68.76,15.92,104.71,30.59c13.49,5.49,24.78,10.79,31.21,14.96 c0.99,0.65,2.03,1.27,3.08,1.87c23.99,13.82,63.06,18.65,84.54,17.31c22.42-1.38,72.06-51.34,202.03-79.74 c50.85-11.11,113.04-15.72,149.57-9.71c27.39,4.51,50.49,21.5,60.33,29.71c1.25,1.05,2.52,2.09,3.8,3.13 c3.92,3.14,7.91,6.18,12.02,9.08c0,0,0.03,0.01,0.07,0.04c0.03,0.03,0.06,0.04,0.07,0.06c1.8,1.27,3.78,2.64,5.86,4.09 c12.49,8.66,29.42,19.9,41.51,26.01c11.74,5.94,22.45,14.63,29.74,21.3c6.07,5.53,9.78,9.68,9.78,9.68s4.48-1.66,6.7,1.84 c2.84,4.47,4.93,5.65,10.48,8.66c5.55,3.01-0.55,8.52-9.31,11.46c-16.15,5.42-43.17,35.68-43.92,36.51 c-0.01,0.01-0.01,0.01-0.01,0.01s37.68,0,52.02-3.01c11.87-2.48,16.12-7.98,20.26-6.53c0.85,0.3,1.71,0.91,2.62,1.9 C786.55,212.97,783.09,233.76,781.24,235.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.8015,
    y1: 255.0072,
    x2: 759.9565,
    y2: 111.2705
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M781.24,235.62c-1.84,1.84-2.61-2.67-6.93-3.01c-8.56-0.69-71.89,24.51-82.06,22.88c-2-0.32-5-0.19-8.52,0.23 c-4.6,0.55-10.1,1.6-15.45,2.75c-0.01,0-0.01,0-0.03,0c-1.01,0.23-2.03,0.45-3.03,0.68c-3.2,0.72-6.25,1.47-8.93,2.13 c-20.03-5.42-49.16-5.56-62.18-9.08c-18.46-4.99-23.57-54.97-23.57-54.97s-6.54-34.15-15.29-49.32 c-3.11-5.42-3.14-11.3-1.86-16.61c-120.46-4.02-181.33,13.89-319.76,48.34c-43.89,10.92-86.92,5.81-108.45-0.26 c1.28-30.69,17.87-54.01,17.87-54.01c23.99,13.82,63.06,18.65,84.54,17.31c22.42-1.38,72.06-51.34,202.03-79.74 c50.85-11.11,113.04-15.72,149.57-9.71c27.39,4.51,50.49,21.5,60.33,29.71c1.25,1.05,2.52,2.09,3.8,3.13 c3.92,3.14,7.91,6.18,12.02,9.08c0,0,0.03,0.01,0.07,0.04c0.03,0.03,0.06,0.04,0.07,0.06c0.17,0.12,0.35,0.24,0.52,0.36 c1.66,1.17,3.46,2.42,5.35,3.73c12.49,8.66,29.42,19.9,41.51,26.01c11.74,5.94,22.45,14.63,29.74,21.3 c0.49,0.45,0.95,0.88,1.41,1.31c5.23,4.86,8.37,8.37,8.37,8.37s4.48-1.66,6.7,1.84c2.84,4.47,4.93,5.65,10.48,8.66 c5.55,3.01-0.55,8.52-9.31,11.46c-16.15,5.42-43.17,35.68-43.92,36.51c-0.01,0.01-0.01,0.01-0.01,0.01s37.68,0,52.02-3.01 c11.87-2.48,16.12-7.98,20.26-6.53c0.85,0.3,1.71,0.91,2.62,1.9C786.55,212.97,783.09,233.76,781.24,235.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 483.135,
    y1: 41.5164,
    x2: 484.6289,
    y2: 140.855
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M644.46,86.96c-171.33,18.98-160.57,22.36-252.43,22.36c-27.77,0-67.82-4.97-68.72-12.91 c27.62-11.82,62.38-23.88,106.31-33.47c50.85-11.11,113.04-15.72,149.57-9.71c27.39,4.51,50.49,21.5,60.33,29.71 c1.25,1.05,2.52,2.09,3.8,3.13C643.71,86.37,644.09,86.66,644.46,86.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 726.4897,
    y1: 211.4726,
    x2: 741.5203,
    y2: 191.8172
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7B681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0591,
    style: {
      stopColor: "#F6AE7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E3351C"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M742.4,213.68c0,0,0,0-0.01,0c-16.34,1.14-36.05,1.14-36.05,1.14s0,0,0.01-0.01 c0.24-0.27,3.37-3.79,8.04-8.54c0,0,0-0.01,0.01-0.01C715.25,205.97,740.89,197.58,742.4,213.68z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 395.5728,
    y1: 97.7085,
    x2: 361.7015,
    y2: 21.498
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M583.96,54.14c-1.57-0.35-3.16-0.65-4.76-0.91c-36.53-6.01-98.72-1.4-149.57,9.71 c-5.07,1.11-10.03,2.25-14.87,3.43c-0.97,0.23-1.93,0.46-2.88,0.71c-0.97,0.23-1.92,0.48-2.85,0.71c-0.95,0.24-1.9,0.48-2.84,0.72 c-13.14,3.37-25.36,6.95-36.73,10.63c-1.14,0.37-2.26,0.75-3.39,1.12c-2.41,0.79-4.77,1.59-7.1,2.41 c-1.07,0.36-2.13,0.73-3.18,1.11l-2.16,0.78c-0.66,0.23-1.33,0.46-1.99,0.71l-0.01,0.01c-1.59,0.58-3.14,1.14-4.68,1.71 c-3.11,1.15-6.14,2.32-9.11,3.49c-4.08,1.6-8.03,3.2-11.84,4.81c-2.02,0.85-4.01,1.7-5.95,2.55c-0.63,0.27-1.25,0.55-1.87,0.82 c-0.35,0.14-0.69,0.3-1.04,0.45c-0.14,0.07-0.3,0.13-0.45,0.2c-4.34,1.93-8.49,3.85-12.46,5.75c-3.03,1.43-5.97,2.85-8.79,4.27 c-3.62,1.8-7.06,3.57-10.36,5.29c-2.69,1.41-5.29,2.8-7.78,4.14c-4.86,2.62-9.34,5.12-13.47,7.42c-2.81,1.57-5.46,3.05-7.97,4.44 c-3.26,1.82-6.27,3.47-9.06,4.93c-0.09,0.04-0.17,0.09-0.24,0.13l-4.18,2l-4.43,2.13c-0.04,0.01-0.07,0.01-0.11,0.02l-6.95-0.65 l-29.16-2.68l-6.02-0.56c0.16-0.91,0.33-1.8,0.53-2.69c1.18-5.5,3.01-10.86,5.33-16.07c0.4-0.91,0.82-1.82,1.27-2.72 c2.65-5.49,5.84-10.78,9.41-15.82c0.33-0.5,0.68-0.99,1.04-1.48c3.73-5.16,7.82-10.06,12.09-14.67c0.24-0.27,0.49-0.53,0.75-0.79 c3.98-4.27,8.1-8.26,12.22-11.97c0.19-0.19,0.39-0.36,0.58-0.52c5.5-4.94,10.98-9.37,16.08-13.21c0.14-0.12,0.3-0.23,0.45-0.33 c5.53-4.18,10.58-7.65,14.71-10.35c0.07-0.06,0.16-0.1,0.23-0.16c6.43-4.19,10.55-6.47,10.55-6.47 c5.73,2.12,16.01,9.37,20.74,12.82c2.84,2.07,6.8-0.5,5.94-3.92c0-0.01-0.01-0.03-0.01-0.04c-0.13-0.46-0.26-0.75-0.26-0.75 c1.41,0.79,3.17,2.02,5.22,3.54c0.01,0.01,0.03,0.01,0.06,0.04c3.42,2.59,10.87,9,14.26,11.94c1.4,1.22,3.44,1.57,5.06,0.66 c1.08-0.6,1.56-1.45,1.73-2.37c0.5-2.64-1.57-5.84,0.49-5.45c2.46,0.46,4.81,3.63,8.04,5.1h0.03c1.11,0.49,2.32,0.78,3.69,0.68 c0.76-0.06,1.22-0.39,1.48-0.88c1.43-2.98-5.01-12.39-1.48-11.5c1.1,0.27,2.16,1.05,3.24,2.03c0,0,0,0,0,0.01 c2.98,2.68,6.08,6.84,10.16,5.79c4.14-1.07,0.65-7.71-0.32-11.14c-0.35-1.2-0.37-2,0.32-2.06c1.7-0.13,4.31,4.21,8.3,6.99 c2.31,1.61,5.07,2.69,8.4,2.09c5.19-0.95,3.57-6.25,1.97-10.52c-0.03-0.07-0.04-0.12-0.04-0.12c-1.2-3.17-2.35-5.72-0.69-5.46 c1.47,0.23,2.59,1.82,3.9,3.62c0,0,0.01,0.01,0.03,0.04c2.19,2.98,4.9,6.6,10.59,5.84c5.46-0.73,4.16-7.28,2.87-12.22 c-0.01-0.03-0.01-0.04-0.01-0.04c-0.86-3.31-1.71-5.89-0.48-5.48c1.18,0.39,2.91,2.84,4.99,5.48c3.34,4.27,7.59,9.03,11.93,6.48 c3.86-2.28,3.34-8.05,2.51-12.58c-0.01-0.04-0.01-0.07-0.01-0.07c-0.68-3.65-1.54-6.46-0.43-5.91c1.14,0.58,2.84,3.33,5.16,6.08 c0,0,0.01,0.01,0.03,0.06c2.72,3.23,6.25,6.46,10.69,6.24c5.12-0.26,3.89-7.25,2.77-12.26c-0.01-0.04-0.03-0.06-0.03-0.06 c-0.69-3.05-1.33-5.35-0.48-4.93c1.51,0.73,3.66,5.97,7.98,9.16c0,0,0.01,0.01,0.03,0.04c2.16,1.57,4.86,2.67,8.27,2.46 c5.2-0.32,5.84-5.66,5.59-10.49v-0.01c-0.24-4.73-1.34-8.96,0.19-7.44c0.89,0.89,1.9,2.33,3.04,3.89c0,0,0,0.01,0.01,0.04 c0,0.01,0,0.03,0.01,0.03c2.85,3.9,6.38,8.5,10.33,7.18c2.15-0.72,2.39-4.16,2.23-7.46c-0.23-5.32-1.5-10.29,2.31-3.05 c0.63,1.21,1.27,2.26,1.87,3.16c0,0,0,0,0.01,0.01c5.35,7.87,9.68,4.93,9.68,4.93c3.46-1.38,3.9-4.83,3.62-8.08 c-0.01-0.07-0.03-0.1-0.03-0.1c-0.4-4.09-1.99-7.87-0.3-6.73c1.33,0.88,2.31,3.4,3.69,5.92v0.01c1.77,3.26,4.19,6.54,8.83,6.33 c3.63-0.17,4.57-3.5,4.58-7.03c0.03-4.48-1.43-9.31-0.79-8.53c0.59,0.73,2.06,3.92,4.34,7.03c0,0,0,0.01,0.03,0.04 c-0.01,0.01-0.01,0.03,0,0.03c2.1,2.87,4.9,5.63,8.29,6.31c3.52,0.69,4.6-2.81,4.8-6.5V7.59c0.19-3.47-0.4-7.1-0.49-7.59 c0,0.01,0.01,0.03,0.03,0.04c0.04,0.1,0.1,0.29,0.22,0.53c1.2,2.65,6.08,12.69,12.02,13.14c3.75,0.29,5.48-3.47,6.25-6.92 c0.66-2.84,0.69-5.48,0.69-5.48s3.42,3.92,5.82,12.39c0,0,0.04,0.13,0.12,0.39c0.03,0.12,0.07,0.22,0.1,0.33 c2.54,7.74,8.16,7.35,13.07,6.37c1.02-0.2,1.63-0.79,1.99-1.6c1.44-3.13-1.1-9.39,1.93-6.8c1.28,1.1,2.1,2.55,2.84,4.05 c0,0,0,0.01,0.01,0.04c1.44,2.87,2.65,5.84,6.63,6.59c2.8,0.53,3.65-1.69,3.75-4.24c0.13-2.82-0.68-6.04-0.76-6.41 c5.43,8.7,8.31,19.8,6.63,35.42C580.17,52.74,583.29,53.93,583.96,54.14z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 697.8712,
    y1: 256.7957,
    x2: 768.9442,
    y2: 225.3739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7B681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5104,
    style: {
      stopColor: "#F6774C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F53919"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M781.24,235.62c-1.84,1.84-2.61-2.67-6.93-3.01c-8.47-0.68-70.53,23.98-81.72,22.93 c4.77-7.46,20.06-24.41,63.52-36.38c0.01,0,0.01,0,0.03-0.01c1.89-0.39,3.85-0.78,5.88-1.18c7.9-1.54,20.46-3.62,16.59-12.67 c0,0,0-0.01,0.01-0.01c0.85,0.3,1.71,0.91,2.62,1.9C786.55,212.97,783.09,233.76,781.24,235.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 505.3726,
    y1: 274.133,
    x2: 465.8006,
    y2: 335.2897
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M555.25,263.62c0,0-0.16,0.29-0.46,0.81c-0.36,0.65-0.95,1.63-1.66,2.94c0,0-0.03,0.01-0.03,0.03 c-1.22,2.15-2.91,5.1-4.88,8.52c-8.18,14.27-23.11,39.15-27.31,46.1c-0.68,1.15-2.02,1.7-3.31,1.41 c-0.03-0.01-0.06-0.01-0.07-0.01c-1.76-0.4-3.57,0.33-4.54,1.84l-12.64,19.78c-2.42,3.33-6.37,5.2-10.48,4.94 c-3.65-0.25-8.34-0.86-13.16-2.38c-0.33-0.12-0.68-0.22-1.02-0.35c-4.35-1.48-8.75-3.75-12.44-7.16 c-0.39-0.35-0.75-0.71-1.11-1.08c-2.87-2.94-5.23-6.67-6.71-11.37c-0.35-1.07-0.65-2.19-0.88-3.37c-0.27-1.27-0.48-2.61-0.62-4.01 c-0.43-4.35-0.79-8.16-1.1-11.48c-0.2-2.29-0.37-4.37-0.52-6.22c-1.3-16.14-0.71-17.25-0.71-17.25s6.47-0.12,15.76-1.07 c2.69-0.27,5.61-0.62,8.69-1.07c4.7-0.66,9.76-1.54,14.86-2.71c3.34-0.75,6.7-1.63,9.99-2.64c0.33-0.1,0.65-0.2,0.97-0.32 c6.83-2.15,13.29-4.91,18.56-8.44c0.12-0.07,0.22-0.14,0.33-0.22l11.11-1.69l12.19-1.84h0.01l8.82-1.34h0.01L555.25,263.62z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 618.5168,
    y1: 248.4875,
    x2: 650.4586,
    y2: 188.2895
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M683.73,255.72c-4.6,0.55-10.1,1.6-15.45,2.75c-0.01,0-0.01,0-0.03,0c-15.61,1.02-15.55-3.59-16.02-8.05 c-0.36-3.27-1.69-10.29-7.29-11.27c-1.58-0.27-3.21,0.09-4.65,0.82c-2.26,1.15-5.17,5.36-6.99,5.4 c-4.58,0.13,0.01-11.7-5.32-12.15c-5.33-0.43-11.2,6.08-13.26,5.46c-2.05-0.63,3.46-12.9-2.67-18.36 c-5.56-4.96-16.31-0.72-19.44-4.51c-3.11-3.78,4.38-8.24,5.45-9.93c1.07-1.7,1.69-6.51-4.37-7.58c-6.07-1.07-10.79-2.94-11.5-4.99 c-0.72-2.06,17.46-1.25,15.14-7.13c-2.32-5.88-6.86-9.45-5.43-11.14c1.43-1.7,9.01,0.53,9.71-3.66c0.72-4.19-6.24-6.5-6.6-8.37 c-0.35-1.87,4.11,0.07,5.62-0.76c1.51-0.85,2.68-1.38,1.25-4.24c-1.43-2.84,7.69-2.72,7.69-2.72s-11.89,64.9,40.81,72.35 c2.18,6.87,8.88,12.88,15.39,16.38c2.51,1.34,5,2.29,7.41,2.81L683.73,255.72z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.0861,
    y1: 173.9756,
    x2: -11.6861,
    y2: 169.4459
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5418,
    style: {
      stopColor: "#E3351C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M129.68,210.64c1.71,4.9,3.95,9.86,6.83,14.81c-46.73,22.39-101.92,32.81-125.49,36.5 c-6.18,0.97-11.64-4.18-10.97-10.4c0.62-5.72,1.86-12.72,4.24-19.28c1.4-3.85,3.21-7.56,5.53-10.75 c6.84-9.42,10.97-22.02,13.29-32.94c1.43-6.77,2.18-12.88,2.44-17.22c0.23-3.69-1.41-10.01-3.9-17.69 c-3.24-9.99-7.94-22.25-11.87-33.89c-2.33-6.87-4.39-13.53-5.72-19.38c-5.32-23.36,0-22.44,0-22.44 c17.15-0.17,68.76,15.92,104.71,30.59c13.49,5.49,24.78,10.79,31.21,14.96c0.99,0.65,2.03,1.27,3.08,1.87 c0,0-6.95,9.76-12.19,24.97c-2.12,6.14-3.96,13.16-4.96,20.78c-1.05,7.95-1.18,16.57,0.26,25.52 C126.9,201.24,128.04,205.91,129.68,210.64z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M575.07,46.02c-3.63,3.36-6.34-1.33-6.74-7.23c-0.39-5.72-3.66-21.31-3.86-22.29 c1.44,2.87,2.65,5.84,6.63,6.59c2.8,0.53,3.65-1.69,3.75-4.24C574.83,18.85,578.68,42.67,575.07,46.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M534.46,41.93c-1.22-6.31-13-36.59-14.84-41.36c1.2,2.65,6.08,12.69,12.02,13.14 c3.75,0.29,5.48-3.47,6.25-6.92h0.01c0,0,5.78,22.08,8.95,30.12S535.77,48.79,534.46,41.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M551.88,42.91c-0.86-6.37-6.48-25.81-7.36-28.8c2.48,8.08,8.18,7.69,13.17,6.7c1.02-0.2,1.63-0.79,1.99-1.6 c0,0,2.9,11.5,4.77,19.87C566.35,47.51,552.82,49.83,551.88,42.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M483.75,45.58c-1.3-6.76-10.35-30.85-10.62-31.6c5.35,7.87,9.68,4.93,9.68,4.93 c3.46-1.38,3.9-4.83,3.62-8.08c0.48,1.59,6.69,22.02,9.73,29.74C499.31,48.6,485.08,52.44,483.75,45.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M489.79,9.91v0.01c-0.01-0.01-0.01-0.01-0.01-0.01H489.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M499.85,43.56c-1.31-6.76-9.8-32.81-10.06-33.63c1.77,3.26,4.19,6.54,8.83,6.33 c3.63-0.17,4.57-3.5,4.58-7.03c0,0,5.86,21.28,9.03,29.32C515.41,46.59,501.16,50.42,499.85,43.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M516.92,41.93c-1.28-6.64-9.63-32.52-10.14-34.14c2.1,2.87,4.9,5.63,8.29,6.31c3.52,0.69,4.6-2.81,4.8-6.5 c0.23,0.76,6.34,21.41,9.45,29.31C532.47,44.96,518.23,48.79,516.92,41.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M466.22,47.95c-1.28-6.64-9.34-32.21-9.84-33.8c2.85,3.9,6.38,8.5,10.33,7.18 c2.15-0.72,2.39-4.16,2.23-7.46h0.01c0,0,6.48,21.04,9.65,29.08C481.76,50.98,467.53,54.81,466.22,47.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M448.22,49.83c-1.28-6.64-8.52-23.13-8.96-24.16c2.16,1.57,4.86,2.67,8.27,2.46 c5.2-0.32,5.84-5.66,5.59-10.49c0.32,1.12,5.35,19.19,7.49,27.18C462.84,53.16,449.53,56.69,448.22,49.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M430.15,52.71c-2.49-6.99-11.31-24.18-11.86-25.25c2.72,3.23,6.25,6.46,10.69,6.24 c5.12-0.26,3.89-7.25,2.77-12.26c0.45,1.08,7.74,18.46,10.79,26.25C445.71,55.74,432.5,59.28,430.15,52.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M409.46,57.9c-1.31-6.84-10.35-24.5-10.35-24.5c3.34,4.27,7.59,9.03,11.93,6.48 c3.86-2.28,3.34-8.05,2.51-12.58c0.37,1.25,5.48,18.57,8.52,26.33C425.24,61.67,410.78,64.76,409.46,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M391.4,62.94c-1.28-6.64-9.73-22.15-10.25-23.11c2.19,2.98,4.9,6.6,10.59,5.84 c5.46-0.73,4.16-7.28,2.87-12.22c0.36,0.98,6.11,16.69,9.18,24.48C406.95,65.97,392.71,69.8,391.4,62.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M374.95,68.16c-3.11-7.23-7.36-17.98-7.36-17.98c2.31,1.61,5.07,2.69,8.4,2.09 c5.19-0.95,3.57-6.25,1.97-10.52c0.56,1.34,5.86,13.98,8.86,21.6C389.99,71.38,377.71,74.57,374.95,68.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M359.75,72.58c-3.18-7.67-10.3-21.4-10.62-21.99c2.98,2.68,6.08,6.84,10.16,5.79 c4.14-1.07,0.65-7.71-0.32-11.14c0,0,8.57,13.86,11.74,21.9C373.87,75.2,362.41,79.02,359.75,72.58z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M304.21,105.06c-3.03,1.43-5.97,2.85-8.79,4.27c-17.05-16.4-43.2-31.9-57.1-39.63 c0.19-0.19,0.39-0.36,0.58-0.52C255.06,76.72,286.78,92.16,304.21,105.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M285.06,114.61c-2.69,1.41-5.29,2.8-7.78,4.14c-14.78-13.53-37.41-27.72-51.93-36.28 c0.24-0.27,0.49-0.53,0.75-0.79C242.67,89.93,269.27,103.73,285.06,114.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M263.81,126.17c-2.81,1.57-5.46,3.05-7.97,4.44c-12.2-11.59-29.8-23.43-43.62-31.99 c0.33-0.5,0.68-0.99,1.04-1.48C229.46,105.4,250.68,116.83,263.81,126.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M242.35,137.67l-4.41,2.12c-0.03,0.01-0.06,0.03-0.09,0.03l-6.99-0.65c-8.66-7.85-19.32-15.49-29.32-22 c0.4-0.91,0.82-1.82,1.27-2.72C216.83,121.69,232.19,130.25,242.35,137.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M325.98,95.29c-2.02,0.85-4.01,1.7-5.95,2.55c-0.63,0.27-1.25,0.55-1.87,0.82 c-0.35,0.14-0.69,0.3-1.04,0.45c-18.49-17.28-48.66-35.42-62.15-43.14c0.14-0.12,0.3-0.23,0.45-0.33 C270.85,63.19,306.83,81.47,325.98,95.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M346.94,86.99c-3.11,1.15-6.14,2.32-9.11,3.49c-20.43-18.66-56.31-38.95-67.7-45.19 c0.07-0.06,0.16-0.1,0.23-0.16C283.3,51.25,325.8,72.05,346.94,86.99z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 522.5563,
    y1: 218.9951,
    x2: 654.3266,
    y2: 164.8999
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M665.22,259.15c-9.93,2.25-18.53,4.67-18.53,4.67c-1.27,0.33-2.51,0.65-3.72,0.95 c-52.52,9.37-66.48-17.18-70.79-37.19c-5.99-27.79-22.18-64.76-34.06-77.73c-6.07-6.62-25.97-18.34-7.37-24.42 c5.83-1.91,16.92-10.25,23.82-16.93c6.92-6.67,19.08-6.92,29.58-5.25c10.49,1.67,24.28-6.44,24.28-6.44s-7.28,13.96-17.91,17.62 c-10.65,3.66-27.45,6.8-26.7,14.05c0.75,7.25,9.39,29.19,5.07,38.17c-4.32,8.99,5.66,20.97,10.65,33.27 c4.99,12.31,0.99,19.29,8.65,27.94c7.65,8.65,24.96,26.48,64.04,22.55l9.88,6.54C662.11,256.96,663.44,257.89,665.22,259.15z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 614.6732,
    y1: 149.3308,
    x2: 728.1925,
    y2: 122.8919
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M734.03,147.96c-8.11,5.22-18.07,9.05-29.34,10.56c-45.35,6.08-22.62-2.8-47.21,18.93 c-24.6,21.74-41.7,9.21-40.2-34.37c0.69-19.67,18.79-35.65,38.73-47.48c1.66,1.17,3.46,2.42,5.35,3.73 c12.49,8.66,29.42,19.9,41.51,26.01c11.74,5.94,22.45,14.63,29.74,21.3C733.11,147.09,733.57,147.52,734.03,147.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 674.4203,
    y1: 163.1306,
    x2: 639.1435,
    y2: 95.2611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 662.43,
    cy: 140.07,
    rx: 29.03,
    ry: 24.38
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 658.2489,
    y1: 125.2008,
    x2: 643.0129,
    y2: 71.0587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7B681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0591,
    style: {
      stopColor: "#F6AE7C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E3351C"
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 662.43,
    cy: 140.07,
    rx: 24.49,
    ry: 20.56
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 663.04,
    cy: 139.91,
    r: 16.62
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st15",
    cx: 660.05,
    cy: 133.59,
    r: 6.32
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 649.6628,
    y1: 201.6681,
    x2: 761.7025,
    y2: 201.6681
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M750.27,178.29c-16.15,5.42-43.17,35.68-43.92,36.51c-0.01,0.01-0.01,0.01-0.01,0.01 s-12.22,7.64-14.38,20.23c-2.16,12.58-14.03,15.5-26.17,8.99c-8.6-4.63-17.54-13.63-15.94-23.21c0.63-3.95,3.08-7.98,8.07-11.86 c17.08-13.27,84.48-52.64,84.48-52.64s4.48-1.66,6.7,1.84c2.06,3.24,3.73,4.76,6.61,6.5c1.08,0.65,2.35,1.34,3.86,2.16 C765.13,169.84,759.03,175.35,750.27,178.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 767.1948,
    y1: 126.7061,
    x2: 706.5756,
    y2: 195.0094
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7B681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5104,
    style: {
      stopColor: "#F6774C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F53919"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M750.27,178.29c-16.15,5.42-43.17,35.68-43.92,36.51c-0.01,0.01-0.01,0.01-0.01,0.01 s-12.22,7.64-14.38,20.23c-2.16,12.58-14.03,15.5-26.17,8.99c-8.6-4.63-17.54-13.63-15.94-23.21 c-0.43,14.45,14.55,18.52,23.86,17.32c12.49-1.61,11.84-16.66,23.5-29.61c11.67-12.97,32.52-27.25,45.19-33.16 c6.47-3.01,10.66-7.32,13.31-10.71c1.08,0.65,2.35,1.34,3.86,2.16C765.13,169.84,759.03,175.35,750.27,178.29z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.419,
    y1: 221.1917,
    x2: 259.6519,
    y2: 290.3968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M367.8,259.28c0,0-0.06,0.19-0.2,0.55c-1.31,3.59-9.47,23.91-28.33,35.01c0,0,8.03-16.73,6.99-17.9 c-3.23-3.67-30.79,31.25-30.79,31.25s1.4-8.34-1.34-12.48c-0.81-1.18-1.93-2.02-3.52-2.22c-0.06-0.01-0.13-0.03-0.19-0.03 c-13.36-1.31-19.94,11.38-19.94,11.38s-0.61-4.21-4.34-5.33c-3.73-1.11-28.67,18.75-28.67,18.75s-2.85-1.83-7.25-5.1 c-0.14-0.1-0.3-0.22-0.46-0.35c-3.79-2.84-8.66-6.7-13.83-11.35c-0.3-0.27-0.61-0.55-0.92-0.84c-4.51-4.12-9.19-8.83-13.56-13.96 c-0.42-0.49-0.84-0.99-1.24-1.5c-3.36-4.08-6.47-8.42-9.11-12.93c-0.53-0.91-1.04-1.82-1.51-2.74c-2.58-4.84-4.55-9.87-5.63-15 c-0.06-0.26-0.1-0.5-0.16-0.75c-0.39-1.89-0.69-3.65-0.92-5.26c-2.91-20.22,6.01-20.3,23.46-19.88c0.22,0,0.43,0.01,0.65,0.01 c3.88,0.1,9.48,0.23,14.87-0.27c5.1-0.48,10-1.51,13.05-3.69c0,0,0,0,0.01,0c0.29,0.1,0.59,0.22,0.88,0.32c0,0,1.93,0.72,5.5,1.99 c2.9,1.02,6.89,2.42,11.79,4.09c3.2,1.1,6.79,2.31,10.72,3.6c3.63,1.21,7.56,2.49,11.76,3.83c4.19,1.34,8.66,2.75,13.34,4.21 c3.95,1.21,8.04,2.45,12.28,3.72c3.52,1.05,7.15,2.1,10.85,3.17c4.03,1.17,8.17,2.33,12.39,3.5c3.65,1.01,7.35,2.02,11.1,3.01 C359.56,257.18,363.66,258.25,367.8,259.28z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M367.8,259.28c0,0-0.06,0.19-0.2,0.55c-1.31,3.59-9.47,23.91-28.33,35.01c0,0,8.03-16.73,6.99-17.9 c-3.23-3.67-30.79,31.25-30.79,31.25s1.4-8.34-1.34-12.48c-0.81-1.18-1.93-2.02-3.52-2.22c15.53-11.4,32.23-24.7,44.91-37.39 C359.56,257.18,363.66,258.25,367.8,259.28z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M344.43,253.1c-26.76,20.99-75.29,49.35-94.21,60.07c-0.14-0.1-0.3-0.22-0.46-0.35 c16.56-10.74,57.34-38.16,82.28-63.23C336.07,250.77,340.21,251.93,344.43,253.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M321.19,246.43c-22.98,18.14-62.59,41.93-85.26,55.04c-0.3-0.27-0.61-0.55-0.92-0.84 c19.68-13.16,52.72-36.46,73.91-57.93C312.86,243.92,316.95,245.16,321.19,246.43z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M295.57,238.5c-20.2,15.62-51.74,35-74.12,48.17c-0.42-0.49-0.84-0.99-1.24-1.5 c19.24-13.21,45.42-32.42,63.6-50.51C287.44,235.88,291.37,237.16,295.57,238.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M273.09,231.07c-16.44,12.9-41.07,28.55-61.99,41.18c-0.53-0.91-1.04-1.82-1.51-2.74 c17.42-12.51,37.29-27.94,51.72-42.54C264.2,228,268.19,229.4,273.09,231.07z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M241.85,228.36c-11.2,8.2-24.74,17.08-38.06,25.4c-0.39-1.89-0.69-3.65-0.92-5.26 c-2.91-20.22,6.01-20.3,23.46-19.88c0.22,0,0.43,0.01,0.65,0.01C230.85,228.74,236.46,228.86,241.85,228.36z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M555.25,263.62c0,0-0.16,0.29-0.46,0.81c-0.36,0.65-0.95,1.63-1.66,2.94c0,0-0.03,0.01-0.03,0.03 c-17.39,18.54-54.8,64.84-76.38,80.2c-0.33-0.12-0.68-0.22-1.02-0.35c13.73-12.97,52.18-60.87,68.37-81.93h0.01l8.82-1.34h0.01 L555.25,263.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M531.88,267.17c-17.64,19.57-48.44,56.87-68.62,72.93c-0.39-0.35-0.75-0.71-1.11-1.08 c13.76-14.31,41.44-48.46,58.29-69.94c0.12-0.07,0.22-0.14,0.33-0.22L531.88,267.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M501.88,277.51c-14.29,16.35-31.89,36.51-46.44,50.13c-0.35-1.07-0.65-2.19-0.88-3.37 c10.63-12.09,24.4-28.86,36.37-43.8c3.34-0.75,6.7-1.63,9.99-2.64C501.25,277.73,501.56,277.63,501.88,277.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M476.07,283.17c-7.51,8.53-15.49,17.48-23.23,25.61c-0.2-2.29-0.37-4.37-0.52-6.22 c4.96-5.92,10.07-12.16,15.06-18.31C470.08,283.97,472.99,283.62,476.07,283.17z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.268,
    y1: 116.3226,
    x2: 16.3089,
    y2: 111.1279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M143.06,125.38c0,0-6.95,9.76-12.19,24.97c-39.53-20.52-107.22-29.01-121.1-30.58 c-2.33-6.87-4.39-13.53-5.72-19.38c-5.32-23.36,0-22.44,0-22.44c17.15-0.17,68.76,15.92,104.71,30.59 c13.49,5.49,24.78,10.79,31.21,14.96C140.97,124.15,142,124.77,143.06,125.38z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.7377,
    y1: 176.7794,
    x2: 12.7786,
    y2: 171.5847
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M126.17,196.65c-2.72-0.14-5.52-0.52-8.27-1.17c-20.95-4.96-61.67-9.25-94.79-6.9 c1.43-6.77,2.18-12.88,2.44-17.22c0.23-3.69-1.41-10.01-3.9-17.69c30.3,3.8,77.87,10.42,104.27,17.46 C124.86,179.08,124.73,187.7,126.17,196.65z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.1612,
    y1: 238.0272,
    x2: 9.202,
    y2: 232.8325
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M136.51,225.45c-46.73,22.39-101.92,32.81-125.49,36.5c-6.18,0.97-11.64-4.18-10.97-10.4 c0.62-5.72,1.86-12.72,4.24-19.28c24.8-7.41,77.22-21.2,125.39-21.63C131.4,215.54,133.63,220.49,136.51,225.45z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.7224,
    y1: 187.4554,
    x2: 484.0394,
    y2: 215.0932
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F7B681"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5104,
    style: {
      stopColor: "#F6774C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F53919"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M560.22,218.92c-1.89,9.99-9.27,17.52-16.96,23.04c-5.39,3.86-10.92,6.74-14.84,8.8 c-1.02,0.53-1.93,1.01-2.71,1.44c-0.86,0.48-1.56,0.88-2.02,1.22c-3.93,2.94-11.66,7.45-24.57,9.91 c-9.68,1.86-22.28,2.55-38.4,0.55c-23.11-2.87-42.21-14.06-54.84-26.31c-7.74-7.48-13.05-15.35-15.4-21.93 c-0.06-0.17-0.12-0.33-0.17-0.49c-3.36-9.9-0.72-20.65,5.53-29.67c4.71-6.8,11.47-12.62,19.27-16.38 c0.03-0.01,0.07-0.03,0.1-0.04c17.16-8.26,50.75-11.51,80.23-5.01c9.14,2.02,19.27,6.17,28.86,10.36 c4.12,1.8,8.16,3.59,11.96,5.23c10.42,4.48,18.78,12.94,22.54,23.63c0.13,0.37,0.26,0.75,0.36,1.12 C560.84,209.73,561.06,214.56,560.22,218.92z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st25"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.207,
    y1: 183.0343,
    x2: 559.1571,
    y2: 183.0343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M559.16,204.4c-9.86,2.93-27.44,0.17-47.9-12.39c-32.8-20.16-71.63-23.3-96.05-22.94 c17.16-8.26,50.75-11.51,80.23-5.01c9.14,2.02,19.27,6.17,28.86,10.36c4.12,1.8,8.16,3.59,11.96,5.23 c10.42,4.48,18.78,12.94,22.54,23.63C558.93,203.65,559.06,204.02,559.16,204.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 388.84,
    y1: 212.1886,
    x2: 560.2235,
    y2: 212.1886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M560.22,218.92c-1.89,9.99-9.27,17.52-16.96,23.04c-3.99-1.08-8.27-2.82-12.82-5.37 c-41.67-23.33-78-35.01-106.27-29.63c-12.77,2.44-24.54,6.48-33.69,8.69c-0.06-0.17-0.12-0.33-0.17-0.49 c-3.36-9.9-0.72-20.65,5.53-29.67c19.44-3.53,49.15-6.15,70.43,4.64C500.32,207.42,529.93,221.78,560.22,218.92z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.884,
    y1: 247.8289,
    x2: 528.4219,
    y2: 247.8289
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M528.42,250.77c-1.02,0.53-1.93,1.01-2.71,1.44c-0.86,0.48-1.56,0.88-2.02,1.22 c-3.93,2.94-11.66,7.45-24.57,9.91c-9.68,1.86-22.28,2.55-38.4,0.55c-23.11-2.87-42.21-14.06-54.84-26.31 c10.74-5.25,26.95-9.77,47.23-5.04C482.02,239.28,503.77,247.65,528.42,250.77z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 567.437,
    y1: 226.2112,
    x2: 423.5761,
    y2: 207.2821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C31F0E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4585,
    style: {
      stopColor: "#DE321A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF4828"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M525.71,252.21c-0.86,0.48-1.56,0.88-2.02,1.22c-3.93,2.94-11.66,7.45-24.57,9.91 c-36.96-40.04,7.25-76.61,25.17-88.94c4.12,1.8,8.16,3.59,11.96,5.23c10.42,4.48,18.78,12.94,22.54,23.63 C569,232.34,535.66,246.72,525.71,252.21z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishResult11);
export default __webpack_public_path__ + "static/media/fish-result-11.218ded119c3bfc12b5146750c1bb483f.svg";
export { ForwardRef as ReactComponent };